import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import CrossMobileForm from '../forms/CrossMobileForm'
import { getCustomer } from '../redux/actions'
import { connect } from 'react-redux'
import DataSource from '../DataSource'
import NotificationBar from "../components/NotificationBar";

const style = {
    maxWidth: '200px',
    position: 'absolute',
    right: '1.5rem'
}

const mobileStyle = {
    maxWidth: '200px',
    position: 'relative',
    marginLeft: 'auto'
}

class CrossSellMobileModule extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoadingPlans: false,
            plans: [],
            mobileNumbers: [],
            defaultPlan: {},
            hasError: false
        }
    }

    componentDidMount () {
        this.getMobileNumbers()
        this.getPlans()
    }

    handleSuccess (response, state) {
        this.props.getCustomer()
    }

    getPlans () {
	    this.setState({
            isLoadingPlans: true,
            hasError: false
        })
        DataSource.getData('/api/getCrossMobilePlans', result => {
            this.setState({
                isLoadingPlans: false,
                plans: result.plans
            }, () => {
                this.setState({
                    defaultPlan: this.state.plans[2]
                })
            })
        }, error => {
            this.setState({
                hasError: true,
                isLoadingPlans: false
            })
        })
    }

    getMobileNumbers () {
        DataSource.getData(`${process.env.MIX_API_URL}v1/available-mobile-numbers?type=free`, response => {
            if (response.data) {
                const data = []
                response.data.forEach(item => {
                    data.push({ label: item.mobile_number, value: item.mobile_number })
                })
                this.setState({ mobileNumbers: data })
            }
        }, (error) => {
            this.setState({ hasError: true })
            console.error(error)
        })
    }

    render () {
        return (
            <div className='module' style={{ overflow: 'visible' }}>
                <div id='sub-navigation' />{/* This is for scrollToNav method in FormHOC */}
                <Heading title='Order your new SIM-only mobile plan' />
                <div className='p-4'>
                    <div className='row mb-4' style={{ position: 'relative' }}>
                        <img src='/images/SlashMyBill_Full.svg' alt='slash my bill image' style={style} className='slash-bill-desktop d-lg-block d-none' />
                        <div className='col-12 col-lg-10 offset-lg-1 text-center'>
                            <h1 className='m-0 mb-3 color-indigo'>ExeSIM 4G & 5G mobile plans <br /> with data rollover</h1>
                            <img src='/images/SlashMyBill_Full.svg' alt='slash my bill image' style={mobileStyle} className='d-lg-none mb-3' />
                            <p className='m-0 lh'>Choose your new ExeSIM mobile plan with <span className='bold'>huge data allowances</span>. As a valued Exetel home broadband customer, the more products you bundle with Exetel, the more you save. <span className='bold'>SLASH UP TO $15 OFF</span> your monthly Exetel broadband bill when you purchase an ExeSIM mobile plan. Learn more at <span className='bold color-grey' style={{ cursor: 'pointer' }} onClick={this.props.onScroll}>Things you need to know.</span></p>
                        </div>
                    </div>
                    <div className='my-3 d-flex justify-content-center align-items-center flex-column'>
                        <a href="https://files.exetel.com.au/cis/mobile/2025-01-23/Exetel_Prepaid_Mobile_CIS.pdf" target="_blank" className="color-grey underline mt-1 text-center">
                            Exetel Residential Mobile Voice Critical Information Summary
                        </a>
                    </div>
                    <CrossMobileForm
                        handleSuccess={this.handleSuccess.bind(this)}
                        mobileNumbers={this.state.mobileNumbers}
                        plans={this.state.plans}
                        defaultPlan={this.state.defaultPlan}
                        isLoadingPlans={this.state.isLoadingPlans}
                        hasErrpr={this.state.hasError}
                    />
                </div>
            </div>
        )
    }
}

CrossSellMobileModule.propTypes = {
    onScroll: PropTypes.func
}

const mapStateToProps = state => ({

})

export default connect(mapStateToProps, { getCustomer })(CrossSellMobileModule)



// WEBPACK FOOTER //
// ./resources/js/modules/CrossSellMobileModule.js